import {createAction} from '@reduxjs/toolkit';

interface FinishPagesMovePayload {
    slugsToUpdate: Record<string, string>;
}

export const finishPagesMove = createAction<FinishPagesMovePayload>('pages/finish-move');
